import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import cn from 'classnames';

import Action from './action';
import PlanCalculator from './plan-calculator';
import { InView } from 'react-intersection-observer';
import { PageContext } from '../context/page-context';

import{ TimelyPlanName } from '../utils/pricing/TimelyPlanName';
import {
    getSoloMonthlyPrice,
    getPlanMonthlyPrice,
    getFixedMonthlyPrice,
    getRegionPriceInfo,
} from '../utils/pricing/calculator';


const toBase64 = (str) =>
    typeof window === 'undefined'
        ? Buffer.from(str).toString('base64')
        : window.btoa(str);

const shimmer = (w, h) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
  <linearGradient id="g">
  <stop stop-color="#fff" offset="20%" />
  <stop stop-color="#f1f1f1" offset="50%" />
  <stop stop-color="#fff" offset="70%" />
</linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#fff" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

class TeamSizeChooser extends React.Component {
    constructor(props) {
        super(props);

        this.goto = this.goto.bind(this);
        this.getPricingDescription = this.getPricingDescription.bind(this);

        // const countryCode = (userInfo.geolocation === 'Unknown') ? 'US' : userInfo.geolocation;
    }


    getPricingDescription(description) {
        const { geolocation } = this.context;
        const { sign } = getRegionPriceInfo(geolocation);

        const soloStart = getSoloMonthlyPrice(geolocation, TimelyPlanName.BUILD);
        const staffStart = getPlanMonthlyPrice(geolocation, TimelyPlanName.BUILD, 2);
        const fixedStart = getFixedMonthlyPrice(geolocation, TimelyPlanName.ELEVATE);

        description = description.replace(
            '%solo',
            `${sign}${soloStart}`
        );
        description = description.replace(
            '%staff',
            `${sign}${staffStart}`
        );
        description = description.replace(
            '%fixed',
            `${sign}${fixedStart}`
        );

        return description;
    }

    goto(e, ref) {
        window.location = ref;
    }

    render() {
        let {
            block: {
                config: { className },
            }
        } = this.props;

        const {
            block: {
                config: { titleClassNames },
                content
            }
        } = this.props;

        const classNames = className ? `${className} container TeamSizeChooserMain` : 'container TeamSizeChooserMain';
        const titleClasses = titleClassNames
            ? titleClassNames
            : 'TeamSizeChooser--main-title u-textCenter';

        // For now we use the same component for all the calculators and pricing page
        // Todo: remove team size chooser and use plan calculator directly
        const forceShow = className.indexOf('forceShow') !== -1;
        className = className.replace('forceShow', '');

        return (

            <InView>
                {({ inView, ref, entry }) => {

                    // console.log(this.props);
                    return (
                        <div ref={ref}>
                            {!forceShow && <PlanCalculator isDetail={this.props.block.config.isDetail} className={`${className}`} />}
                            {forceShow && <div className="TeamSizeChooser-defaults">
                                <div ref={el => (this.compRef = el)} className={cn(classNames)}>
                                    <h2 className={titleClasses}>{content.title}</h2>
                                    <div className="TeamSizeChooser">
                                        {content.cards.map((pricing, key) => {
                                            const actionHref = pricing.actions[0].url;
                                            return (
                                                <div
                                                    onClick={e => {
                                                        this.goto(e, actionHref);
                                                    }}
                                                    key={key}
                                                    className="TeamSizeChooser-item">
                                                    <div className="TeamSizeChooser-item-img">
                                                        <Image
                                                            src={pricing.image.src}
                                                            alt={pricing.image.alt}
                                                            placeholder="blur"
                                                            blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(168, 96))}`}
                                                            width={168}
                                                            height={96}
                                                        />
                                                    </div>
                                                    <h3 className="TeamSizeChooser-title">
                                                        {pricing.title}
                                                    </h3>
                                                    <p className="Pricing-pitch-desc">
                                                        {this.getPricingDescription(
                                                            pricing.description
                                                        )}
                                                    </p>
                                                    <div className="TeamSizeChooser-action">
                                                        {pricing.actions.map((action, key) => {
                                                            return (
                                                                <Action
                                                                    key={key}
                                                                    action={action}
                                                                    isFull={true}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {content.footer && (
                                        <div className="TeamSizeChooser--footer row">
                                            <div className="col-md-8 col-md-offset-2">
                                                <p
                                                    className="u-textCenter u-vSpacing"
                                                    dangerouslySetInnerHTML={{
                                                        __html: content.footer
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            }
                        </div>
                    );
                }}
            </InView>

        );
    }
}

TeamSizeChooser.propTypes = {
    block: PropTypes.shape({
        content: PropTypes.shape({})
    })
};

TeamSizeChooser.contextType = PageContext;

export default TeamSizeChooser;
